import { useFormik } from 'formik'
import _ from 'lodash'
import { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { useCustomReducer } from '../../../../../base/customHooks'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import { translate } from '../../../../../base/localization'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { uuidv4 } from '../../../../../base/utils'
import { exportToXLSX, getDateByTimezoneOffset } from '../../../../../base/utils/dataHelper'
import InputCampaign from '../../../../../components/InputCampaign'
import IPButton from '../../../../../components/IPButton'
import IPInput from '../../../../../components/IPInput'
import IPSelectBox from '../../../../../components/IPSelectBox'
import { ISelectOption } from '../../../../../components/IPSelectBox/IPSelectBox'
import Translations from '../../../../../translations'
import { getBanksApi, getCompanyApi } from '../../../components/api'
import { CommonPostResponse, IBanks, ICompany } from '../../../components/models/models'
import { GetAllFcvService } from '../../../ProductOperation/CampaignBundleCrud/services/GetAllFcvService'
import { IListAllFCV } from '../../../ProductOperation/CampaignBundleCrud/services/InsertFcvService'
import { IBank, ICampaign, IPostInstallment, ProcedureInstalment } from '../models/models'
import { AddInstallemntsApi } from '../services/addInstallemntsApi'
import { DeleteInstallemntsApi } from '../services/deleteInstallemntsApi'
import { UpdateInstallemntsApi } from '../services/updateInstallemntsApi'
interface IListInstallmentState {
  dealerCodes: ISelectOption[]
  type?: ISelectOption | null
  bankName?: ISelectOption
  installment?: ISelectOption
  company?: ISelectOption
  campaing?: ISelectOption | null
  buttonName: string
}

interface IPosData {
  Id: number
  Name: string
}

class ListPosDataApi extends ClientProxy {
  constructor() {
    super({
      url: 'admin/posTransaction/listPosData',
      requesterInfo: {},
    })
  }

  public async listPosData(): Promise<IPosData[]> {
    return await this.getAsync<IPosData[]>()
  }
}
function BankAdd(props: BaseComponentWithContextProps) {
  let navigate = useNavigate()
  const t = translate(Translations)
  const getInitialState = (): IListInstallmentState => {
    return {
      dealerCodes: [],
      buttonName: 'Ekle',
    }
  }
  const intialState = getInitialState()
  const [state, setState] = useCustomReducer<IListInstallmentState>(intialState)
  const [companies, setCompanies] = useState<ISelectOption[]>([])
  const [installment, setInstallment] = useState<ProcedureInstalment[]>([])
  const [bank, setBank] = useState<ISelectOption[]>([])
  const [campaing, setCampaing] = useState<ICampaign[]>([])
  const [posDataList, setPosDataList] = useState<IPosData[]>([])
  const [bulkPosSelections, setBulkPosSelections] = useState<Record<string, ISelectOption[]>>({})
  const [company, setCompany] = useState<boolean>(false)
  const [types, setTypes] = useState<boolean>(false)
  const [campaings, setCampaings] = useState<boolean>(false)
  const location = useLocation()

  const inititalStartDate = new Date()
  inititalStartDate.setDate(1)
  inititalStartDate.setHours(0)
  inititalStartDate.setMinutes(0)
  inititalStartDate.setSeconds(0)
  const [startDate, setStartDate] = useState(inititalStartDate)
  const [endDate, setEndDate] = useState<Date | undefined>(undefined)

  const makeBankOptionValue = (bankId: number | string, bankName: string) =>
    `${bankId}::${bankName}`

  const getRealBankId = (optionValue: string | number) => {
    const raw = String(optionValue)
    if (raw.includes('::')) return Number(raw.split('::')[0])
    return Number(raw)
  }

  const toDateTimeLocal = (date: Date | undefined) => {
    if (!date) return ''
    return date
      .toLocaleString('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
      .replace(' ', 'T')
  }

  const getDate = async (data: any, title: string) => {
    if (title === 'Start') setStartDate(data)
    else setEndDate(data)
  }

  useEffect(() => {
    getCompanies()
    getPosData()
    addInstallmentField(0)
  }, [])

  const getPosData = async () => {
    try {
      const res = await new ListPosDataApi().listPosData()
      setPosDataList(res || [])
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err?.description || 'POS listesi alınırken hata oluştu.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    }
  }

  const getCompanies = async () => {
    const company: ICompany[] = await getCompanyApi()
    const data: ISelectOption[] = []
    company
      .filter(c => {
        return c.Name !== 'İndex Grup'
      })
      .map(com => {
        if (com.Name === 'Index') data.push({ value: '1000', label: com.Name })
        if (com.Name === 'Datagate') data.push({ value: '1100', label: com.Name })
        if (com.Name === 'Despec') data.push({ value: '1200', label: com.Name })
        if (com.Name === 'Netex') data.push({ value: '2300', label: com.Name })
      })
    setCompanies(data)
  }

  const getBanks = async (option: ISelectOption) => {
    if (
      state.company &&
      state.company.value !== option.value &&
      (state.type || (installment && installment[0].BankName) || state.campaing)
    ) {
      Swal.fire({
        icon: 'question',
        title: `Daha önce girdiniz bilgiler silinecektir. Emin misiniz?`,
        showConfirmButton: true,
        allowOutsideClick: false,
        showDenyButton: true,
        confirmButtonText: 'Evet',
        denyButtonText: 'Hayır',
      }).then(async result => {
        if (result.isConfirmed) {
          setState({ company: option, type: null, campaing: null })
          setInstallment([
            {
              StateId: uuidv4(),
              Id: 0,
              BankName: [],
              InstalmentRate: null,
              TermDay: '',
              Add: true,
              BankGroupId: uuidv4(),
              Update: false,
              Order: 0,
            },
          ])
          const banks: IBanks[] = await getBanksApi(String(option.value))
          const data: ISelectOption[] = []
          banks.map(b => data.push({ value: makeBankOptionValue(b.BankID, b.BankName), label: b.BankName }))
          setBank(data)
        } else {
          return
        }
      })
    } else {
      setState({ company: option })
      const banks: IBanks[] = await getBanksApi(String(option.value))
      const data: ISelectOption[] = []
      banks.map(b => data.push({ value: makeBankOptionValue(b.BankID, b.BankName), label: b.BankName }))
      setBank(data)
    }
  }

  const getTypes = async (option: ISelectOption) => {
    if (
      state.type &&
      state.type.value !== option.value &&
      ((installment && installment[0].BankName) || state.campaing)
    ) {
      Swal.fire({
        icon: 'question',
        title: `Daha önce girdiniz bilgiler silinecektir. Emin misiniz?`,
        showConfirmButton: true,
        allowOutsideClick: false,
        showDenyButton: true,
        confirmButtonText: 'Evet',
        denyButtonText: 'Hayır',
      }).then(async result => {
        if (result.isConfirmed) {
          setState({ type: option, campaing: null })
        } else {
          return
        }
      })
    } else {
      setState({ type: option })
    }
  }
  const type = [
    { value: '3', label: 'Cari Ödeme' },
    { value: '0', label: 'Avantaj POS' },
    { value: '1', label: 'Fırsat POS' },
    { value: '2', label: 'FÇV2' },
  ]
  const installmentAddNum = [
    {
      value: '1',
      label: t('pages.admin.BankAndInstallementOperation.bankCrud.bankAdd.installment', ['1']),
    },
    {
      value: '2',
      label: t('pages.admin.BankAndInstallementOperation.bankCrud.bankAdd.installment', ['2']),
    },
    {
      value: '3',
      label: t('pages.admin.BankAndInstallementOperation.bankCrud.bankAdd.installment', ['3']),
    },
    {
      value: '4',
      label: t('pages.admin.BankAndInstallementOperation.bankCrud.bankAdd.installment', ['4']),
    },
    {
      value: '5',
      label: t('pages.admin.BankAndInstallementOperation.bankCrud.bankAdd.installment', ['5']),
    },
    {
      value: '6',
      label: t('pages.admin.BankAndInstallementOperation.bankCrud.bankAdd.installment', ['6']),
    },
    {
      value: '9',
      label: t('pages.admin.BankAndInstallementOperation.bankCrud.bankAdd.installment', ['9']),
    },
    {
      value: '12',
      label: t('pages.admin.BankAndInstallementOperation.bankCrud.bankAdd.installment', ['12']),
    },
    {
      value: '15',
      label: t('pages.admin.BankAndInstallementOperation.bankCrud.bankAdd.installment', ['15']),
    },
    {
      value: '18',
      label: t('pages.admin.BankAndInstallementOperation.bankCrud.bankAdd.installment', ['18']),
    },
    {
      value: '24',
      label: t('pages.admin.BankAndInstallementOperation.bankCrud.bankAdd.installment', ['24']),
    },
  ]

  const addInstallmentField = (id: number) => {
    // Yeni elemanı oluşturun
    const newInstallment = {
      StateId: uuidv4(),
      Id: 0,
      BankName: [],
      InstalmentRate: null,
      TermDay: '',
      Add: true,
      BankGroupId: uuidv4(),
      Update: false,
      Order: id,
    }

    // Yeni elemanı mevcut installment dizisine ekleyin
    const updatedInstallment = [...installment]

    // Eğer dizide eleman varsa ve eklenecek yer belirlenmişse
    if (id >= 0 && id < updatedInstallment.length) {
      updatedInstallment.splice(id + 1, 0, newInstallment) // Ekleme işlemini gerçekleştir
    } else {
      updatedInstallment.push(newInstallment) // Belirlenen konum yoksa dizinin sonuna ekle
    }

    // Güncellenmiş diziyi state'e set edin
    setInstallment(updatedInstallment)
  }

  const copyInstallmentField = (item: ProcedureInstalment, id: number) => {
    const dt: ISelectOption[] = []
    item.BankName.forEach(ba => {
      dt.push({ value: Number(ba.value), label: ba.label })
    })

    const newInstallment = {
      StateId: uuidv4(),
      Id: 0,
      BankName: dt,
      InstalmentRate: null,
      TermDay: '',
      Add: true,
      BankGroupId: uuidv4(),
      Update: false,
      Order: id,
    }

    const updatedInstallment = [...installment]

    if (id >= 0 && id < updatedInstallment.length) {
      updatedInstallment.splice(id + 1, 0, newInstallment)
    } else {
      updatedInstallment.push(newInstallment)
    }

    setInstallment(updatedInstallment)
  }

  const { validateField, setFieldValue, setFieldTouched, values } = useFormik({
    initialValues: {
      Type: '',
      DealerCodes: [],
      Installment: 0,
      BankName: '',
      InterestRate: 0,
      StartDate: startDate,
      EndDate: endDate,
      Id: 0,
      BankId: '',
      Company: '',
      PaymentTermsId: 0,
    },

    onSubmit: async values => {
      values['Location'] = values['Location']['value']
    },
  })

  const addInstallment = async () => {
    //#region Validation
    if (!state.company) {
      Swal.fire({
        icon: 'error',
        title: 'Şirket seçmelisiniz',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
      return
    }
    if (!state.type) {
      Swal.fire({
        icon: 'error',
        title: 'Tip seçmelisiniz',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
      return
    }
    if (state.type.value !== '3' && (!state.campaing || !state.campaing.value)) {
      Swal.fire({
        icon: 'error',
        title: 'Kampanya seçmelisiniz',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
      return
    }
    if (installment.length === 0) {
      Swal.fire({
        icon: 'error',
        title: 'Banka Taksit girmelisiniz',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
      return
    }
    //#endregion

    const clnValues = _.clone(values)
    clnValues.StartDate = new Date(startDate)
    clnValues.EndDate = endDate ? new Date(endDate) : undefined
    clnValues.DealerCodes = state.dealerCodes ? (state.dealerCodes.map((item: ISelectOption) => item.label) as any) : []
    clnValues.Type = state.type ? String(state.type.value) : ''
    clnValues.BankName = state.bankName ? state.bankName.label : ''
    clnValues.BankId = state.bankName ? String(state.bankName.value) : ''
    clnValues.Company = state.company ? String(state.company.value) : ''
    clnValues.PaymentTermsId = state.type?.value !== '3' ? (state.campaing ? Number(state.campaing.value) : 0) : 0

    clnValues.InterestRate = Number(values.InterestRate)
    const data: IPostInstallment[] = []
    let BankBool: boolean = false

    installment.map((ins, index) => {
      if (!ins.TermDay) {
        Swal.fire({
          icon: 'error',
          title: 'Vade oranı boş bırakılamaz!',
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        BankBool = true
        return
      }
      if (ins.BankName && ins.BankName.length > 0 && ins.InstalmentRate && Number(ins.InstalmentRate.value) > 0 && !(endDate === undefined || endDate === null)) {
        ins.BankName.map(bname => {
          data.push({
            Id: ins.Id,
            Type: state.type ? String(state.type.value) : '',
            DealerCodes: [],
            Company: clnValues.Company,
            Installment: ins.InstalmentRate ? Number(ins.InstalmentRate.value) : 0,
            BankName: bname.label,
            InterestRate: Number(ins.TermDay),
            StartDate: getDateByTimezoneOffset(startDate) as any,
            EndDate: endDate && getDateByTimezoneOffset(endDate) as any,
            BankId: String(getRealBankId(bname.value)),
            PaymentTermsId: clnValues.PaymentTermsId,
            BankGroupId: ins.BankGroupId ? ins.BankGroupId : '',
          })
        })
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Banka taksit bilgileriniz eksiktir.',
          showConfirmButton: true,
          allowOutsideClick: false,
        }).then(async result => { })
        BankBool = true
      }
    })
    if (!BankBool) {
      if (state.buttonName === 'Ekle') {
        const addInstallemnt: AddInstallemntsApi = new AddInstallemntsApi({})
        addInstallemnt
          .addInstallemnts(data)
          .then((result: CommonPostResponse) => {
            if (result) {
              Swal.fire({
                icon: 'success',
                title: 'Banka Taksit Eklendi',
                showConfirmButton: true,
                allowOutsideClick: false,
              }).then(async result => {
                navigate(
                  '/admin/BankAndInstallementOperation/BankCrud' +
                  (location.state?.url ? '?' + location.state?.url : '')
                )
              })
            }
          })
          .catch((err: any) => {
            Swal.fire({
              icon: 'error',
              title: err.description,
              showConfirmButton: true,
              allowOutsideClick: false,
            })
          })
      } else {
        const updateInstallemnts: UpdateInstallemntsApi = new UpdateInstallemntsApi({})
        updateInstallemnts
          .updateInstallemnts(data)
          .then((result: CommonPostResponse) => {
            if (result) {
              Swal.fire({
                icon: 'success',
                title: 'Banka Taksit Güncellendi',
                showConfirmButton: true,
                allowOutsideClick: false,
              }).then(async result => {
                navigate(
                  '/admin/BankAndInstallementOperation/BankCrud' +
                  (location.state?.url ? '?' + location.state?.url : '')
                )
              })
            }
          })
          .catch((err: any) => {
            Swal.fire({
              icon: 'error',
              title: err.description,
              showConfirmButton: true,
              allowOutsideClick: false,
            })
          })
      }
    }
  }

  const handleBankName = (e, item) => {
    const restrictedValues = [9001, 1402, 2701, 21402, 22701]
    const tempInstallment = _.clone(installment)

    // Check if all selected banks are restricted (and not in posDataList)
    const hasOnlyRestrictedBanks = e && e.length > 0 &&
      e.every((bank: ISelectOption) => {
        const bankId = getRealBankId(bank.value)
        const isRestricted = restrictedValues.includes(bankId)
        // Eğer restricted ama posDataList'te varsa (special POS), restricted sayma
        if (isRestricted && isPosBankLabel(bank.label)) {
          return false
        }
        return isRestricted
      })

    if (tempInstallment.length > 1) {
      const foundItem = tempInstallment.find(desc => desc.StateId === item.StateId) as any
      foundItem.BankName = e
      foundItem.Add = false

      // If only restricted banks are selected, force installment to '1'
      if (hasOnlyRestrictedBanks && foundItem.InstalmentRate?.value !== '1') {
        foundItem.InstalmentRate = installmentAddNum.find(ins => ins.value === '1')
      }
    } else {
      tempInstallment[0].BankName = e
      if (
        tempInstallment[0].TermDay !== '' &&
        (tempInstallment[0].InstalmentRate ||
          tempInstallment[0].InstalmentRate ||
          tempInstallment[0].TermDay ||
          tempInstallment[0].TermDay)
      )
        tempInstallment[0].Add = false

      // If only restricted banks are selected, force installment to '1'
      if (hasOnlyRestrictedBanks && tempInstallment[0].InstalmentRate?.value !== '1') {
        tempInstallment[0].InstalmentRate = installmentAddNum.find(ins => ins.value === '1')
      }
    }
    setInstallment(tempInstallment)
  }

  const handleInstalmentRate = (e, item) => {
    const tempInstallment = _.clone(installment)
    const restrictedValues = [9001, 1402, 2701, 21402, 22701];

    // If selected installment rate is not '1', remove restricted normal POS banks from the list
    if (e.value !== '1') {
      if (tempInstallment.length > 1) {
        const foundItem = tempInstallment.find(desc => desc.StateId === item.StateId)
        if (foundItem && foundItem.BankName) {
          foundItem.BankName = foundItem.BankName.filter(bank => {
            const bankId = getRealBankId(bank.value)
            const isRestricted = restrictedValues.includes(bankId)

            if (isRestricted) {
              // Keep if it's a special POS bank in posDataList
              if (isPosBankLabel(bank.label)) {
                return true
              }
              // Remove normal POS banks
              return false
            }
            return true
          })
          foundItem.InstalmentRate = e
          foundItem.Add = false
        }
      } else {
        if (tempInstallment[0].BankName) {
          tempInstallment[0].BankName = tempInstallment[0].BankName.filter(bank => {
            const bankId = getRealBankId(bank.value)
            const isRestricted = restrictedValues.includes(bankId)

            if (isRestricted) {
              // Keep if it's a special POS bank in posDataList
              if (isPosBankLabel(bank.label)) {
                return true
              }
              // Remove normal POS banks
              return false
            }
            return true
          })
        }
        tempInstallment[0].InstalmentRate = e
        if (tempInstallment[0].TermDay !== '' && (tempInstallment[0].BankName || tempInstallment[0].BankName))
          tempInstallment[0].Add = false
      }
    } else {
      // If installment is '1', update normally without filtering
      if (tempInstallment.length > 1) {
        const foundItem = tempInstallment.find(desc => desc.StateId === item.StateId)
        if (foundItem) {
          foundItem.InstalmentRate = e
          foundItem.Add = false
        }
      } else {
        tempInstallment[0].InstalmentRate = e
        if (tempInstallment[0].TermDay !== '' && (tempInstallment[0].BankName || tempInstallment[0].BankName))
          tempInstallment[0].Add = false
      }
    }
    setInstallment(tempInstallment)
  }

  const getBulkPosOptions = (): ISelectOption[] => {
    const options: ISelectOption[] = [{ value: 'normal-pos', label: 'Normal POS' }]
    posDataList.forEach(pos => options.push({ value: `pos-${pos.Id}`, label: pos.Name }))
    return options
  }

  const normalizeText = (val: string) =>
    (val || '')
      .toLocaleUpperCase('tr-TR')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')

  const isPosBankLabel = (bankLabel: string) => {
    const normalizedLabel = normalizeText(bankLabel)
    return posDataList.some(pos => normalizedLabel.includes(normalizeText(pos.Name)))
  }

  const handleBulkPosChange = (options: ISelectOption[] | null, item: ProcedureInstalment) => {
    const selected = options || []
    const isCariOdeme = state.type?.value === '3'

    if (isCariOdeme) {
      const hasNonNormal = selected.some(x => String(x.value) !== 'normal-pos')
      if (hasNonNormal) {
        Swal.fire({
          icon: 'warning',
          title: 'Cari ödeme seçiliyken toplu tanımda sadece Normal POS kullanılabilir.',
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        return
      }
    }

    if (selected.length === 0) {
      setBulkPosSelections(prev => ({ ...prev, [item.StateId]: [] }))
      return
    }

    const selectedBanksMap: Record<string, ISelectOption> = {}

    selected.forEach(sel => {
      if (String(sel.value) === 'normal-pos') {
        bank
          .filter(a => !isPosBankLabel(a.label))
          .forEach(b => {
            selectedBanksMap[String(b.value)] = b
          })
        return
      }

      const target = normalizeText(sel.label)
      bank
        .filter(a => normalizeText(a.label).includes(target))
        .forEach(b => {
          selectedBanksMap[String(b.value)] = b
        })
    })

    const mergedBanks = Object.values(selectedBanksMap)
    if (mergedBanks.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Seçilen POS tiplerine göre uygun banka bulunamadı.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
      return
    }

    setBulkPosSelections(prev => ({ ...prev, [item.StateId]: selected }))
    setInstallment(prevState =>
      prevState.map((prev: any) => {
        if (prev.StateId === item.StateId) {
          const currentBanks: ISelectOption[] = prev.BankName || []
          const currentMap: Record<string, ISelectOption> = {}
          currentBanks.forEach(b => {
            currentMap[String(b.value)] = b
          })
          mergedBanks.forEach(b => {
            currentMap[String(b.value)] = b
          })

          return {
            ...prev,
            BankName: Object.values(currentMap),
          }
        }
        return prev
      })
    )
  }

  const handleTermDay = (e, item) => {
    const tempInstallment = _.clone(installment)
    if (tempInstallment.length > 1) {
      ; (tempInstallment.find(desc => desc.StateId === item.StateId) as any).TermDay = e
        ; (tempInstallment.find(desc => desc.StateId === item.StateId) as any).Add = false
    } else {
      tempInstallment[0].TermDay = e
      if (tempInstallment[0].InstalmentRate && (tempInstallment[0].BankName || tempInstallment[0].BankName))
        tempInstallment[0].Add = false
    }
    setInstallment(tempInstallment)
  }

  const routeLocation = useLocation()

  const removeInstallmentItem = item => {
    Swal.fire({
      icon: 'question',
      title: 'Silmek istediğinize emin misiniz?',
      showConfirmButton: true,
      allowOutsideClick: false,
      showDenyButton: true,
      confirmButtonText: 'Evet',
      denyButtonText: 'Hayır',
    }).then(async result => {
      if (result.isConfirmed) {
        if (routeLocation.state && (routeLocation.state as any)?.installementData) {
          const deleteInstallemnts: DeleteInstallemntsApi = new DeleteInstallemntsApi({})
          deleteInstallemnts.deleteInstallemnts([item.Id])
        }
        setInstallment(
          installment
            .filter(ins => {
              return ins.StateId !== item.StateId
            })
            .map(i => {
              return i
            })
        )
      }
    })
    return
  }

  useEffect(() => {
    if (
      routeLocation.state &&
      (routeLocation.state as any)?.installementData &&
      companies.length > 0 &&
      routeLocation.state.flag !== 'copy'
    ) {
      setCompany(true)
      setTypes(true)
      setCampaings(true)
      const data = _.clone((routeLocation.state as any)?.installementData)
      const dt = data.Bank
      const res = dt.sort((a, b) => a.BankId - b.BankId)
      companies.map(com => {
        if (String(data.Company) === String(com.value)) {
          getBanks(com)
          setState({ company: com })
        }
      })
      installmentAddNum.map(ins => {
        if (String(data.Installment) === String(ins.value)) {
          setState({ installment: ins })
        }
      })
      if (data.PaymentTermsId > 0 && data.PaymentTermsName.length > 0)
        setState({ campaing: { value: data.PaymentTermsId, label: data.PaymentTermsName } })
      type.map(com => {
        if (String(data.Type) === String(com.value)) {
          setState({ type: com })
          if (String(data.Type) !== '3') {
            // setState({ campaing: com })
            getAllFcv('update', data.PaymentTermsId)
          }
        }
      })
      // setState({ bankName: { value: data.BankId, label: data.BankName } })
      // setFieldValue('Limit', data.Limit)
      // setFieldValue('Id', data.Id)
      // setFieldValue('Installment', data.Installment)
      // setFieldValue('InterestRate', data.InterestRate)
      setStartDate(data.StartDate)
      setEndDate(data.EndDate)
      let dataBank: ProcedureInstalment[] = []
      // let dt: ProcedureInstalment[] = []
      // let bankgrup = "";
      res &&
        res.map((bank: IBank, index) => {
          const InstalmentRate = installmentAddNum
            .filter(ins => {
              return ins.value === String(bank.Installment)
            })
            .pop()
          dataBank.push({
            BankName: [
              {
                value: bank.BankId,
                label: bank.BankName,
              },
            ],
            Id: bank.Id,
            StateId: uuidv4(),
            InstalmentRate: { value: String(bank.Installment), label: InstalmentRate?.label },
            TermDay: String(bank.InterestRate),
            Add: data.Bank.length - 1 === index ? false : true,
            BankGroupId: bank.BankGroupId,
            Update: true,
            Order: index,
          })
          setInstallment(dataBank)
          setCompany(false)
          setState({ buttonName: 'Güncelle' })
        })
    }
  }, [companies])

  useEffect(() => {
    if (
      routeLocation.state &&
      (routeLocation.state as any)?.installementData &&
      companies.length > 0 &&
      routeLocation.state.flag === 'copy'
    ) {
      const data = _.clone((routeLocation.state as any)?.installementData)
      const dt = data.Bank
      const res = dt.sort((a, b) => a.BankId - b.BankId)
      companies.map(com => {
        if (String(data.Company) === String(com.value)) {
          getBanks(com)
          setState({ company: com })
        }
      })
      installmentAddNum.map(ins => {
        if (String(data.Installment) === String(ins.value)) {
          setState({ installment: ins })
        }
      })
      if (data.PaymentTermsId > 0 && data.PaymentTermsName.length > 0)
        setState({ campaing: { value: data.PaymentTermsId, label: data.PaymentTermsName } })
      type.map(com => {
        if (String(data.Type) === String(com.value)) {
          setState({ type: com })
          if (String(data.Type) !== '3') {
            getAllFcv('add')
          }
        }
      })
      setStartDate(data.StartDate)
      setEndDate(data.EndDate)
      let dataBank: ProcedureInstalment[] = []
      res &&
        res.map((bank: IBank, index) => {
          const InstalmentRate = installmentAddNum
            .filter(ins => {
              return ins.value === String(bank.Installment)
            })
            .pop()
          dataBank.push({
            BankName: [
              {
                value: bank.BankId,
                label: bank.BankName,
              },
            ],
            Id: bank.Id,
            StateId: uuidv4(),
            InstalmentRate: { value: String(bank.Installment), label: InstalmentRate?.label },
            TermDay: String(bank.InterestRate),
            Add: data.Bank.length - 1 === index ? false : true,
            BankGroupId: bank.BankGroupId,
            Update: false,
            Order: index,
          })
          setInstallment(dataBank)
          setCompany(false)
          setState({ buttonName: 'Ekle' })
        })
    }
  }, [companies])

  useEffect(() => {
    if (state.type && state.type.value && state.type.value !== '3' && state.company && startDate && endDate) {
      getAllFcv('add')
    } else {
      setCampaing([])
      setState({ campaing: null })
    }
  }, [state.type, state.company, startDate, endDate])

  useEffect(() => {
    if (state.type?.value !== '3') return

    const normalPosOption: ISelectOption = { value: 'normal-pos', label: 'Normal POS' }
    let shouldUpdateInstallment = false

    const nextSelections: Record<string, ISelectOption[]> = {}
    Object.keys(bulkPosSelections).forEach(key => {
      const selections = bulkPosSelections[key] || []
      const hasNonNormal = selections.some(x => String(x.value) !== 'normal-pos')
      if (hasNonNormal) {
        nextSelections[key] = [normalPosOption]
        shouldUpdateInstallment = true
      } else {
        nextSelections[key] = selections
      }
    })

    if (Object.keys(nextSelections).length > 0) {
      setBulkPosSelections(nextSelections)
    }

    if (shouldUpdateInstallment) {
      const normalBanks = bank.filter(a => !isPosBankLabel(a.label))
      setInstallment(prev =>
        prev.map(p => {
          const selected = nextSelections[p.StateId] || []
          if (selected.length === 1 && String(selected[0].value) === 'normal-pos') {
            return { ...p, BankName: normalBanks }
          }
          return p
        })
      )
    }
  }, [state.type?.value])

  const getAllFcv = async (type?: string | boolean, id?: number | undefined) => {
    const req: IListAllFCV = {
      Company: state.company?.value === undefined ? '' : String(state.company?.value),
      Type: state.type?.value === undefined ? undefined : +state.type?.value,
      PaymentTermsName: '',
      StartDate: getDateByTimezoneOffset(startDate),
      EndDate: endDate ? getDateByTimezoneOffset(endDate) : undefined,
      DealerCode: '',
      PageNumber: 0,
      PageSize: 1000,
      PageType: 0,
    }
    try {
      props.showLoading()
      const fcvListAPI: GetAllFcvService = new GetAllFcvService({})
      const result: any = await fcvListAPI.listAllFCV(req)
      // const data: ICampaign[] = [];

      // for (const res of result) {
      //   if (res.Type === Number(state.type?.value) && res.Company === state.company?.value) {
      //     data.push(res);
      //   }
      // }
      // if (
      //   (type === 'add' && (!state.campaing || state.campaing) && (!data || data.length === 0)) ||
      //   (type === 'update' && id === 0)
      // ) {
      //   Swal.fire({
      //     icon: 'error',
      //     title: 'Uygun kampanya bulunamamıştır şirket veya tipi değiştiriniz',
      //     showConfirmButton: true,
      //     allowOutsideClick: false,
      //   });
      //   return;
      // }
      if (result.TotalPaymentCount === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Uygun kampanya bulunamamıştır şirket veya tipi değiştiriniz',
          showConfirmButton: true,
          allowOutsideClick: false,
        })
      }
      setCampaing(result.PaymentTermsList)
      props.hideLoading()
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Kampanya bulunamadı.',
        allowOutsideClick: true,
      })
      props.hideLoading()
    }
  }

  const handleQuantity = (e: any, item: any) => {
    const val = e.target.value
    handleTermDay(val.replace(',', '.'), item)
  }

  const handleQuantityOnBlur = (e: any, item: any) => {
    if (e.target.value?.length < 1 || isNaN(Number(e.target.value)) || Number(e.target.value) < 0) {
      handleTermDay(0, item)
    } else {
      if (Number(e.target.value) < 0) {
        Swal.fire({
          // position: 'top-end',
          icon: 'error',
          title: '0 dan küçük olmalıdır',
          showConfirmButton: true,
          allowOutsideClick: true,
        })
        handleTermDay(0, item)
        return
      }
      handleTermDay(e.target.value, item)
    }
  }

  const excelButton = async () => {
    try {
      if (installment) {
        const data: any[] = []
        if (installment.length > 0) {
          installment.map((p, index) => {
            return data.push({
              Sıra: index + 1,
              'Banka Adı': p.BankName && (p.BankName[0].label as any),
              'Taksit Adedi': p.InstalmentRate && (p.InstalmentRate.label as any),
              Vade: p.TermDay,
            })
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Excele atılacak veri bulunmamaktadır.',
            allowOutsideClick: true,
            backdrop: true,
          })
          return
        }
        exportToXLSX(data, 'Banka Taksitleri')
      }
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }

  return (
    <div className='container'>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header d-flex justify-content-between align-items-center'>
            <div className='col-12 col-md-9 mb-2'>
              <span className='h4'>Banka Taksit {state.buttonName === 'Ekle' ? 'Ekleme' : 'Güncelleme'}</span>
            </div>
            <div className='col-12 col-md-2 mb-2'>
              <div className='buttonsuz'>
                <Link
                  to={`/admin/BankAndInstallementOperation/BankCrud${location.state?.url ? '?' + location.state?.url : ''
                    }`}
                >
                  <IPButton type='button' className='btn btn-primary' text='Listeye Dön' />
                </Link>
              </div>
            </div>
            <div className='col-12 col-md-1'>
              <div className='d-flex align-items-center'>
                <span>Excel: </span>
                <button
                  type='button'
                  style={{
                    border: '1px solid #2e7d32',
                    borderRadius: 0,
                    width: '29px',
                    height: '29px',
                    backgroundColor: 'white',
                    margin: '0 10px',
                  }}
                  onClick={excelButton}
                  className='btn text-capitalize background-white-important d-flex align-items-center'
                >
                  <i
                    className='fas fa-file-excel'
                    style={{
                      marginLeft: '-6px',
                      fontSize: '18px',
                      color: '#2e7d32',
                    }}
                  ></i>
                </button>
              </div>
            </div>
          </div>
          <div className='card-body'>
            <form id='id1' className='formform' noValidate style={{ marginBottom: '350px' }}>
              <div className='form-row'>
                <div className={'form-group col-md-6'}>
                  <label className='labeltext'>Şirket</label>
                  <IPSelectBox
                    isDisabled={company}
                    isClearable
                    options={companies}
                    value={state.company}
                    onChangeSingle={option => {
                      getBanks(option)
                    }}
                  />
                </div>
                <div className={'form-group col-md-6'}>
                  <label className='labeltext'>Tip</label>
                  <IPSelectBox
                    isDisabled={types}
                    isClearable
                    options={type}
                    value={state.type}
                    onChangeSingle={option => {
                      getTypes(option)
                    }}
                  />
                </div>
              </div>
              <div className='form-row'>
                <div className='col-lg-4'>
                  <label className='form-label'>Başlangıç Tarihi</label>
                  <InputCampaign
                    type='datetime-local'
                    id='StartDate'
                    name='StartDate'
                    label={''}
                    value={toDateTimeLocal(startDate)}
                    onChange={e => getDate(e.target.value, 'Start')}
                    isActive
                  />
                </div>
                <div className='col-lg-4'>
                  <label className='form-label'>Bitiş Tarihi</label>
                  <InputCampaign
                    type='datetime-local'
                    id='EndDate'
                    name='EndDate'
                    label={''}
                    value={toDateTimeLocal(endDate)}
                    onChange={e => getDate(e.target.value, 'End')}
                    isActive
                  />
                </div>
                {
                  <div className='form-group col-md-4'>
                    <label className='labeltext'>Kampanya</label>
                    <IPSelectBox
                      isDisabled={campaings ? true : state.type && state.type.value !== '3' ? false : true}
                      isClearable
                      options={
                        campaing &&
                        campaing.map((com: ICampaign) => {
                          return {
                            value: `${com.Id}`,
                            label: com.PaymentTermsName,
                          }
                        })
                      }
                      value={state.campaing}
                      onChangeSingle={option => {
                        setState({ campaing: option })
                      }}
                    />
                  </div>
                }
              </div>
              <br></br>
              <b style={{ color: 'red' }}>Kuveyttürk, Vakıfbank ve Diğer Bankalar seçeneklerinin "NORMAL POS" tanımları sadece peşin yapılabilmektedir.</b>
              <br></br>
              {installment.length > 0 &&
                installment.map((item, index) => {
                  // Determine if the selected installment rate allows restricted banks
                  const isRestrictedRate = item.InstalmentRate && item.InstalmentRate.value !== '1'

                  // Filter bank options based on the selected installment rate
                  const restrictedValues = [9001, 1402, 2701, 21402, 22701]

                  const filteredBanks = isRestrictedRate
                    ? bank.filter(bankOption => {
                      const isRestricted = restrictedValues.includes(getRealBankId(bankOption.value))
                      if (isRestricted) {
                        // Keep if it's a special POS bank in posDataList
                        if (isPosBankLabel(bankOption.label)) {
                          return true
                        }
                        // Remove normal POS banks
                        return false
                      }
                      return true
                    })
                    : bank

                  // Check if all selected banks are restricted (and not in posDataList)
                  const hasOnlyRestrictedBanks = item.BankName && item.BankName.length > 0 &&
                    item.BankName.every(bank => {
                      const bankId = getRealBankId(bank.value)
                      const isRestricted = restrictedValues.includes(bankId)
                      // Eğer restricted ama posDataList'te varsa (special POS), restricted sayma
                      if (isRestricted && isPosBankLabel(bank.label)) {
                        return false
                      }
                      return isRestricted
                    })

                  // Filter installment options if only restricted banks are selected
                  const filteredInstallmentAddNum = hasOnlyRestrictedBanks
                    ? installmentAddNum.filter(ins => ins.value === '1')
                    : installmentAddNum

                  return (
                    <div className='row m-t-10' key={item.StateId}>
                      <div className='col-4'>
                        <label className='labeltext'>Banka</label>
                        <IPSelectBox
                          isDisabled={item.Update}
                          isMulti
                          isClearable
                          id='BankName'
                          name='BankName'
                          onChangeMulti={options => {
                            handleBankName(options, item)
                          }}
                          options={filteredBanks}
                          value={item.BankName}
                        />
                        {!item.Update && !company && bank.length > 0 && (
                          <div style={{ marginTop: '6px' }}>
                            <IPSelectBox
                              isMulti
                              isClearable
                              placeholder='Toplu tanım için POS seçiniz'
                              options={getBulkPosOptions()}
                              value={bulkPosSelections[item.StateId] || []}
                              onChangeMulti={options => handleBulkPosChange(options as ISelectOption[], item)}
                            />
                          </div>
                        )}
                      </div>
                      <div className='col-2'>
                        <label className='labeltext'>Taksit Adedi</label>
                        <IPSelectBox
                          name='InstalmentRate'
                          options={filteredInstallmentAddNum}
                          value={item.InstalmentRate}
                          onChangeSingle={option => {
                            handleInstalmentRate(option, item)
                          }}
                        />
                      </div>
                      <div className='col-2'>
                        <label className='labeltext'>Vade(max)</label>
                        <IPInput
                          name='TermDay'
                          type='text'
                          value={item.TermDay}
                          onChange={e => {
                            handleQuantity(e, item)
                          }}
                          onBlur={e => handleQuantityOnBlur(e, item)}
                        />
                      </div>
                      <div className='col-1'>
                        <label className='labeltext'></label>
                        <IPButton
                          onClick={e => {
                            removeInstallmentItem(item)
                          }}
                          type='button'
                          className='btn btn-danger m-t-5'
                          text='Sil'
                          disabled={installment.length < 2 ? true : false}
                        />
                      </div>
                      <div className='col-1' style={{ marginLeft: '20px' }}>
                        <label className='labeltext'></label>
                        <IPButton
                          onClick={e => {
                            addInstallmentField(index)
                          }}
                          type='button'
                          className='btn btn-success m-t-5'
                          text='Ekle'
                        />
                      </div>
                      <div className='col-1' style={{ marginLeft: '20px' }}>
                        <label className='labeltext'></label>
                        <IPButton
                          onClick={e => {
                            copyInstallmentField(item, index)
                          }}
                          type='button'
                          className='btn btn-success m-t-5'
                          text='Kopyala'
                        />
                      </div>
                    </div>
                  )
                })}
              <div className='form-row mt-4' style={{ float: 'right' }}>
                <IPButton
                  text={state.buttonName}
                  type='button'
                  className='btn btn-success w-25 float-right'
                  onClick={() => addInstallment()}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}
export default componentWithContext(BankAdd)

